import {type SemanticLegendByMetric} from 'src/generated/graphql';

import {
  type BucketCustomization,
  type SemanticLegendSettingsWithCategoricalConfig,
} from '../../types';
import {type SemanticLegendPalette} from './colorPalettes';
import {getColorFromValue} from './getDefaultBucketColors';
import {normalizeNumber} from './numberNormalization';

export function parseBucketsFromSemanticLegendByMetric(
  semanticLegendByMetric: SemanticLegendByMetric,
  semanticLegendPalette: SemanticLegendPalette
) {
  const bucketUpperBounds = semanticLegendByMetric?.bucketUpperBounds ?? [];
  const bucketCustomizations: Record<number, BucketCustomization> = {};
  Object.entries(semanticLegendByMetric?.customColors ?? {}).forEach(
    ([_, customization]) => {
      bucketCustomizations[parseInt(customization.bucketNumber)] = {
        color: customization.colorHex,
      };
    }
  );

  // We only want to return buckets if there are at least 2 buckets
  if (bucketUpperBounds.length <= 1) {
    return {buckets: [], bucketCustomizations};
  }

  const buckets = bucketUpperBounds.map((bucketMax, index) => {
    const bucketMin =
      index > 0 ? bucketUpperBounds[index - 1] : bucketUpperBounds[0];
    return {
      bucketMin: normalizeNumber(bucketMin),
      bucketMax: normalizeNumber(bucketMax),
      color: getColorFromValue(
        index,
        bucketUpperBounds.length,
        semanticLegendPalette
      ),
    };
  });

  return {buckets, bucketCustomizations};
}

export function parseBucketsFromSemanticLegendSettings(
  semanticLegendSettings: SemanticLegendSettingsWithCategoricalConfig
) {
  const customColors = [];
  for (const [bucketNumber, bucket] of Object.entries(
    semanticLegendSettings?.bucketCustomizations ?? {}
  )) {
    if (bucket.color) {
      customColors.push(`${parseInt(bucketNumber)}:${bucket.color}`);
    }
  }
  const bucketUpperBounds = semanticLegendSettings?.buckets?.map(
    (bucket, _) => {
      return normalizeNumber(bucket.bucketMax ?? 0);
    }
  );

  return {customColors, bucketUpperBounds};
}
